"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var styled_1 = require("../../styled");

exports.ButtonContainer = styled_components_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 260px;\n"], ["\n    width: 260px;\n"])));
exports.ButtonLinkFixer = styled_components_1.default(react_native_1.View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-left: 10px;\n"], ["\n    margin-left: 10px;\n"])));
exports.FormSectionPasswordFixer = styled_components_1.default(styled_1.FormSection)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    align-self: self-start;\n"], ["\n    align-self: self-start;\n"])));
exports.FormSectionButtonsFixer = styled_components_1.default(styled_1.FormSection)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 40px 0 60px -20px;\n"], ["\n    margin: 40px 0 60px -20px;\n"])));
exports.ButtonsRow = styled_components_1.default(components_lib_1.RowFlexStartResponsive)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    flex-direction: row;\n"], ["\n    flex-direction: row;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;